export const DEFAULT_ROOT_PATH = "$";

const WILDCARD = "*";

export function hasChildNodes(data, dataIterator) {
	return !dataIterator(data).next().done;
}

export const wildcardPathsFromLevel = (level: number) =>
	// i is depth
	Array.from({ length: level }, (_, i) => [DEFAULT_ROOT_PATH].concat(Array.from({ length: i }, () => "*")).join("."));

const populatePaths = (
	expandedPaths: string[],
	keyPaths: string[],
	dataIterator,
	curData: object,
	curPath: string,
	depth: number
) => {
	if (depth === keyPaths.length) {
		expandedPaths.push(curPath);
		return;
	}
	const key = keyPaths[depth];
	if (depth === 0) {
		if (hasChildNodes(curData, dataIterator) && (key === DEFAULT_ROOT_PATH || key === WILDCARD)) {
			populatePaths(expandedPaths, keyPaths, dataIterator, curData, DEFAULT_ROOT_PATH, depth + 1);
		}
	} else if (key === WILDCARD) {
		for (const { name, data: dt } of dataIterator(curData)) {
			if (hasChildNodes(dt, dataIterator)) {
				populatePaths(expandedPaths, keyPaths, dataIterator, dt, `${curPath}.${name}`, depth + 1);
			}
		}
	} else {
		const value = curData[key];
		if (hasChildNodes(value, dataIterator)) {
			populatePaths(expandedPaths, keyPaths, dataIterator, value, `${curPath}.${key}`, depth + 1);
		}
	}
};

export const getExpandedPaths = (data: object, dataIterator, expandPaths, expandLevel: number, initialState = {}) => {
	const wildcardPaths: string[] = ([] as string[])
		.concat(wildcardPathsFromLevel(expandLevel))
		.concat(expandPaths)
		.filter((path) => typeof path === "string"); // could be undefined

	const expandedPaths: string[] = [];
	wildcardPaths.forEach((wildcardPath) => {
		const keyPaths = wildcardPath.split(".");

		populatePaths(expandedPaths, keyPaths, dataIterator, data, "", 0);
	});

	return expandedPaths.reduce((obj, path) => {
		obj[path] = true;
		return obj;
	}, initialState);
};
